import * as actionTypes from './actionTypes'
import settingsService from 'services/settingsService'

export const closeChangeCompany = () =>{
  return {
    type: actionTypes.SETTINGS_CLOSE_CHANGE_COMPANY
  }
}

export const showChangeCompany = () =>{
  return {
    type: actionTypes.SETTINGS_SHOW_CHANGE_COMPANY
  }
}

export const sendEmailSuport = payload => {
  return dispatch =>{
    settingsService
    .sendEmailSuport(payload)
    .then(data => {
      dispatch(sendEmailSupportSuccess())
    })
    .catch(err => {
      console.log(err)
    })
  }
}

export const deleteAccount = () => {
  return dispatch =>{
    settingsService.deleteAccount().then(dispatch(deleteAccountSuccess()))
  }
}

export const deleteAccountSuccess = () => {
  return {
    type: actionTypes.SETTINGS_ACCOUNT_DELETED
  }
}

export const sendEmailSupportSuccess = () => {
  return {
    type: actionTypes.SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS
  }
}

export const closeSentEmailSupport = () => {
  return {
    type : actionTypes.SETTINGS_CLOSE_SENT_EMAIL_SUPORT
  }
}

export const showErrorUnsubscribe = errorMessageUnsubscribe => {
  return {
    type: actionTypes.SETTINGS_SHOW_ERROR_UNSUBSCRIBE,
    errorMessageUnsubscribe: errorMessageUnsubscribe
  }
}

export const closeErrorUnsubscribe = () => {
  return {
    type: actionTypes.SETTINGS_CLOSE_ERROR_UNSUBSCRIBE
  }
}

export const unsubscribe = (token) => {
 return dispatch => {
    settingsService
    .unsubscribe(token)
    .then(response => {
      if(response.isUnsubscribed){
        dispatch(isUnsubscribeSuccess())
      }else{
        dispatch(showErrorUnsubscribe(response.message))
      }
    })
    .catch(err => {

    })
 }
}

export const isUnsubscribeSuccess = () => {
  return{
    type: actionTypes.SETTINGS_UNSUBSCRIBE_SUCCESS
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Settings.js